<!--
2023-05-31 ytw
-->
<template>
  <div>
    <div class="gift-pop" v-if="userInfo">
      <div class="logined">
        <div v-if="mode===1" class="close-btn">
          <img :src="closeImg" @click="close" alt="closeImg">
        </div>
        <div v-if="mode===2" class="close-btn2">
          <img :src="closeImg" @click="close" alt="fork">
        </div>
        <div class="main-content" v-if="mode===1">
          <div class="dailyFreeCashTop">
            <img :src="dailyFreeCashTop" class="bg" @click="clkVoid" alt="dailyFreeCashTop"/>
            <div class="bg2"/>
            <img :src="fontTop" class="fontTop"  alt="fontTop"/>

            <img :src="textFree" class="textFree" alt="textFree"/>
            <div class="freeDiv">
              <div class="coin-row">
                <div class="coin-item" v-for="(item, i) in freeCoinList" :key="'freeCoin'+i" v-if="i < 4">
                  <img :src="coinFree" class="coin-image-small-1" alt="img"/>
                  <img :src="coinFinish" class="coin-image-small-2" v-if="item.Status===1"/>
                  <img :src="coinUnFinish" class="coin-image-small-2" v-if="item.Status===-1" alt="img"/>
                  <img :src="coinFreeColor" class="coin-image-small-3" alt="img"
                       v-if="(!userInfo&&i===0)||(mayCollectFree&&collectIndex===i&&item.Status===0)"/>
                  <div class="coin-text textShadow" v-if="freeCoinAmountList&&freeCoinAmountList.length>0">
                    <span>{{ $t('lang.account.currencyType') }}{{ freeCoinAmountList[i] }}</span>
                  </div>
                </div>
              </div>
              <div class="coin-row">
                <div class="coin-item" v-for="(item, i) in freeCoinList" :key="'freeCoin'+i" v-if="i > 3">
                  <img :src="coinFree" class="coin-image-small-1" alt="coinFree"/>
                  <img :src="coinFinish" class="coin-image-small-2" v-if="item.Status===1" alt="coinFinish"/>
                  <img :src="coinUnFinish" class="coin-image-small-2" v-if="item.Status===-1" alt="coinUnFinish"/>
                  <img :src="coinFreeColor" class="coin-image-small-3" alt="img"
                       v-if="mayCollectFree&&collectIndex===i&&item.Status===0"/>
                  <div class="coin-text textShadow" v-if="freeCoinAmountList&&freeCoinAmountList.length>0">
                    <span>{{ $t('lang.account.currencyType') }}{{ freeCoinAmountList[i] }}</span></div>
                </div>
                <div class="coin-item"></div>
              </div>
            </div>
            <img :src="textDeposit" class="textDeposit" alt="textDeposit"/>
            <div class="depositDiv">
              <div class="coin-row">
                <div class="coin-item" v-for="(item, i) in depositCoinList" :key="'depositCoin'+i" v-if="i < 4">
                  <img :src="coinDeposit" class="coin-image-small-1" alt="coinDeposit">
                  <img :src="coinFinish" class="coin-image-small-2" v-if="item.Status===1" alt="coinFinish"/>
                  <img :src="coinLock" class="coin-image-small-2" v-if="!isDeposited&&userInfo" alt="coinLock"/>
                  <img :src="coinDepositColor" class="coin-image-small-3" alt="coinDepositColor"
                       v-if="(!userInfo&&i===0)||(collectIndex>=i&&item.Status!=1)">
                  <div class="coin-text" v-if="depositCoinAmountList&&depositCoinAmountList.length>0">
                    <span>{{ $t('lang.account.currencyType') }}{{ depositCoinAmountList[i] }}</span></div>
                </div>
              </div>
              <div class="coin-row">
                <div class="coin-item" v-for="(item, i) in depositCoinList" :key="'depositCoin'+i" v-if="i > 3">
                  <img :src="coinDeposit" class="coin-image-small-1" alt="coinDeposit">
                  <img :src="coinFinish" class="coin-image-small-2" v-if="item.Status===1" alt="coinFinish"/>
                  <img :src="coinLock" class="coin-image-small-2" v-if="!isDeposited&&userInfo" alt="coinLock"/>
                  <img :src="coinDepositColor" class="coin-image-small-3" v-if="collectIndex>=i&&item.Status!==1" alt="coinDepositColor">
                  <div class="coin-text" v-if="depositCoinAmountList&&depositCoinAmountList.length>0">
                    <span>{{ $t('lang.account.currencyType') }}{{ depositCoinAmountList[i] }}</span></div>
                </div>
                <div class="coin-item"></div>
              </div>
            </div>
          </div>
          <div class="operation-row">
            <div class="operation-item" @click="collectGift">
              <div class="blue-btn-1"
                   v-if="blueBtn===1">
                <span v-if="userInfo">{{ $t('lang.dailyFreeCash.collect') }}</span>
                <span v-else>{{ $t('lang.dailyFreeCash.btnCheckIn') }}</span>
              </div>
              <div class="blue-btn-2"
                   v-if="blueBtn!==1">
                <span v-if="userInfo">{{ $t('lang.dailyFreeCash.collect') }}</span>
                <span v-else>{{ $t('lang.dailyFreeCash.btnCheckIn') }}</span>
              </div>
            </div>
            <div class="operation-item">
              <div class="green-btn-1"
                   @click="deposit">
                <span>{{ $t('lang.dailyFreeCash.btnDeposit') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="main-content" v-else>
          <div class="dailyFreeCashTop" style="margin-top: 7vh">
            <div class="bgTask"
                 :style="{backgroundImage:'url('+require('../../assets/images/dailyFreeCash/bgTask.webp')+')'}"/>
            <img :src="fontTop1" alt="fontTop1" class="fontTop2"/>
            <div class="remainTimes">
              <div class="left"/>
              <div>{{ daySpan + $t('lang.taskSign.remain') }}</div>
              <div class="right"/>
            </div>
            <div class="up" v-show="!isTop"><img :src="up" alt="up"/></div>
            <div class="taskDiv" v-if="SevenDayGiftTask&&SevenDayGiftTask.length>0">
              <div ref="scrollableDiv" class="task-row" @scroll="handleScrollTaskRow">
                <div class="task-item" v-for="(item, i) in SevenDayGiftTask" :key="'freeCoin'+i"
                     :style="i===0?'margin:0 1.25vw 1.5vh 1.25vw;':((i===SevenDayGiftTask.length-1)?'margin:1.5vh 1.25vw 0 1.25vw;':'')">
                  <div @click="openMessage(i,item)" class="query" v-if="item.TaskName === 'upi_deposit_amount'">
                    <div class="queryIcon">?</div>
                    <div class="queryMask" v-show="SevenDayGiftTask[i].messageShow">
                      <div class="triangle-up"></div>
                      {{ $t('lang.luckyWheel.include') }}:{{ item.Param }}
                    </div>
                  </div>
                  <div class="item-back"/>
                  <div class="available" v-if="item.Status === 0"/>

                  <div class="item-inner">
                    <div class="taskName">
                      <div v-if="SevenDayGiftTask[i]">{{ $t('lang.taskSign.task') }}</div>
                      <div style="font-size:3.243vh;line-height: 3.243vh;font-weight: 900" v-if="SevenDayGiftTask[i]">
                        {{ item.index + 1 }}
                      </div>
                    </div>
                    <div class="taskShadowBox">
                      <div class="task-content">
                        <div>{{ $t('lang.taskSign.' + item.TaskName).replace('{Amount}', item.TaskAchieveValue) }}
                        </div>

                      </div>
                      <div class="taskShadowBoxRight">
                        <div class="taskImg">
                          <div class="bigCoin"><img :src="bigCoin" alt="bigCoin"/></div>
                          <div class="task-amount">
                  <span v-if="SevenDayGiftTask[i]">{{ $t('lang.account.currencyType') }}{{
                      item.Reward
                    }}</span>
                          </div>
                          <div class="ok" v-if="item&&item.Status === 1"><img :src="ok" alt="ok"/></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="down" v-show="isTop"><img :src="down" alt="down"/></div>
          </div>
          <div class="operation-row2">
            <div class="operation-item" @click="collectGift">
              <div class="blue-btn-1"
                   v-if="blueBtn===1">
                <span v-if="userInfo">{{ $t('lang.dailyFreeCash.collect') }}</span>
                <span v-else>{{ $t('lang.dailyFreeCash.btnCheckIn') }}</span>
              </div>
              <div class="blue-btn-2"
                   v-if="blueBtn!==1">
                <span v-if="userInfo">{{ $t('lang.dailyFreeCash.collect') }}</span>
                <span v-else>{{ $t('lang.dailyFreeCash.btnCheckIn') }}</span>
              </div>
            </div>
            <div class="operation-item">
              <div class="green-btn-1"
                   @click="deposit">
                <span>{{ $t('lang.dailyFreeCash.btnDeposit') }}</span>
              </div>
            </div>
          </div>
        </div>
        <DailyFreeCashConfirm :confirmBtn="confirmBtn" :brownText="brownText" :yellowText="yellowText"
                              :closeConfirm="closeConfirm" :closeAll="closeAll" v-show="showConfirm"></DailyFreeCashConfirm>
      </div>
    </div>
    <NewcomerSignInPop v-else-if="!userInfo && getRouter() && 0" @handleClose="close"/>
  </div>
<!--    <div class="notlogined" :style="{backgroundImage:'url('+require('../../assets/images/freeSign/notLoginPopBg.webp')+')'}" v-else>-->
<!--      <div class="contentBox">-->
<!--        <div class="amount">₹{{SevenDaySettingAmount}}</div>-->
<!--        <div class="getUp">{{$t('lang.taskSign.getUp')}}</div>-->
<!--        <div class="exFNU">{{$t('lang.taskSign.exFNU')}}</div>-->
<!--        <div class="btn" @click="goLogin()">{{$t('lang.login.Continue')}}</div>-->
<!--        <div class="iAlreadyLogin">{{$t('lang.taskSign.iAlreadyLogin')}}<span @click="goLogin()">{{$t('lang.taskSign.loginText')}}</span></div>-->
<!--      </div>-->
<!--      <img @click="close()" src="../../assets/images/home/close.png" alt="" class="close">-->
<!--    </div>-->
</template>
<script>
import ok from '@/assets/images/freeSign/ok.svg'
import bigBox from '@/assets/images/freeSign/bigBox.webp'
import bigCoin from '@/assets/images/freeSign/bigCoin.webp'
import closeImg from '@/assets/images/freeSign/cancel_sign.svg'
import up from '@/assets/images/freeSign/Up.webp'
import down from '@/assets/images/freeSign/Down.svg'
import dailyFreeCashTop from '@/assets/images/freeSign/bk.webp'
import textDeposit from '@/assets/images/dailyFreeCash/textDeposit.png'
import textFree from '@/assets/images/dailyFreeCash/textFree.png'
import fontTop from '@/assets/images/freeSign/freeCash.webp'
import fontTop1 from '@/assets/images/freeSign/freeCash1.webp'
import coinFree from '@/assets/images/dailyFreeCash/coinFree.webp'
import coinFinish from '@/assets/images/dailyFreeCash/finish.png'
import coinUnFinish from '@/assets/images/dailyFreeCash/unFinish.png'
import coinLock from '@/assets/images/dailyFreeCash/lock.png'
import coinFreeColor from '@/assets/images/dailyFreeCash/coinFreeColor.gif'
import coinDepositColor from '@/assets/images/dailyFreeCash/coinDepositColor.gif'
import coinDeposit from '@/assets/images/dailyFreeCash/coinDeposit.webp'
import DailyFreeCashConfirm from '@/components/DailyFreeCashConfirm/index'
import {getTimeSpanString, afListener, fetchBalance, closePop} from '@/utils'
import request from '@/service'
import store from '../../store/store'
import NewcomerSignInPop from '@/components/NewcomerSignInPop'
export default {
  name: 'dailyFreeCash',
  props: ['collectedGiftCount', 'lastCollectGiftTimeSpan', 'handleClose', 'closeRegularlyActivityPop', 'verifyIfPopup7DayGift'],
  data () {
    return {
      SevenDaySettingAmount: this.$store.state.SevenDaySettingAmount ? this.$store.state.SevenDaySettingAmount : localStorage.getItem('SevenDaySettingAmount'),
      fetchBalance,
      isTop: true,
      mode: 2,
      ok,
      up,
      down,
      closeImg,
      bigBox,
      bigCoin,
      daySpan: 7,
      collectedCount: 0,
      cornDays: [],
      getTimeSpanString,
      SevenDayGiftTask: [],
      nextCashTime: '00:00:00',
      canCollect: false,
      hour24MilliSeconds: 24 * 60 * 60 * 1000, // 30 * 1000
      lastCollectTime: -1,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      isCollecting: false,
      completeWithdrawal: false,
      completeDeposit: false,
      haveWeeklyInvitedUsers: false,
      freeCoinList: [0, 0, 0, 0, 0, 0, 0],
      depositCoinList: [0, 0, 0, 0, 0, 0, 0],
      freeCoinAmountList: [],
      depositCoinAmountList: [],
      mayCollectFree: false,
      mayCollectDeposit: false,
      isDeposited: false,
      collectIndex: 0,
      showConfirm: false,
      confirmBtn: 1,
      earnedAmount: 0,
      brownText: '',
      yellowText: 0,
      blueBtn: 1,
      dailyFreeCashTop,
      textDeposit,
      textFree,
      fontTop,
      fontTop1,
      coinFree,
      coinFinish,
      coinUnFinish,
      coinLock,
      coinFreeColor,
      coinDepositColor,
      coinDeposit,
      requestPoint: 0
    }
  },
  components: {
    DailyFreeCashConfirm,
    NewcomerSignInPop
  },
  mounted () {
    if (this.userInfo) {
      this.loadData()
    } else {
      this.getGiftAmount()
    }
  },
  created () {
  },
  updated () {
  },
  watch: {
    '$store.state.SevenDaySettingAmount': function (v) {
      this.SevenDaySettingAmount = v
    },
    'verifyIfPopup7DayGift': function (n) {
      if (n && this.userInfo) {
        if (this.timeSpanCompute()) { // 如果两次请求在两秒内就不再请求
          return
        }
        this.loadData()
      }
    }
  },
  methods: {
    getRouter () {
      return this.$route.name && this.$route.name.toLocaleLowerCase() === 'home'
    },
    goLogin () {
      this.$router.push('/Login')
      // this.$store.commit('setLoginPopShow', true)
    },
    openMessage (i, item) {
      item.messageShow = !item.messageShow
      this.$set(this.SevenDayGiftTask, i, item)
    },
    handleScrollTaskRow (event) {
      const scrollPosition = event.target.scrollTop
      if (scrollPosition < 5) {
        this.isTop = true
      }
      const scrollableDiv = this.$refs.scrollableDiv
      const height = scrollableDiv.clientHeight
      const scrollHeight = scrollableDiv.scrollHeight
      // 判断是否滚动到底部
      if (scrollPosition + height + 5 >= scrollHeight) {
        this.isTop = false
      }
    },
    loadData: function () {
      if (this.userInfo) {
        let url = '/innovation/sevendaygift/get-user-info'
        let data = {'UserId': this.userInfo.UserId}
        request('post', url, data, false).then(res => {
          if (res) {
            // 用于决定是否显示C版签到的飘窗，banner,promotion
            if (res.IsShowIcon && res.SevenDayGiftModel === 'versionC') {
              store.commit('setNewUserIsShowIcon', true)
            } else {
              store.commit('setNewUserIsShowIcon', false)
            }
            let IsShowIcon = false
            if (res.IsShowIcon) {
              IsShowIcon = true
            }
            store.commit('setShowGiftIcon', IsShowIcon)
            if (res.SevenDayGiftModel && res.SevenDayGiftModel === 'version_task') {
              this.mode = 2
              if (res.SevenDayGiftTask) {
                res.SevenDayGiftTask.forEach((e, index) => {
                  e.index = index
                })
                // 已完成(status=1)的排到后面
                res.SevenDayGiftTask.sort((a, b) => {
                  if (a.Status === 1 && b.Status !== 1) {
                    return 1 // a排在b后面
                  } else if (a.Status !== 1 && b.Status === 1) {
                    return -1 // a排在b前面
                  } else {
                    return 0 // 保持不变
                  }
                })
                // 待领取(status=0)的排到后面
                res.SevenDayGiftTask.sort((a, b) => {
                  if (a.Status !== 0 && b.Status === 0) {
                    return 1 // a排在b后面
                  } else if (a.Status === 0 && b.Status !== 0) {
                    return -1 // a排在b前面
                  } else {
                    return 0 // 保持不变
                  }
                })
                this.SevenDayGiftTask = res.SevenDayGiftTask
                this.SevenDayGiftTask.forEach(item => {
                  if (item.TaskName === 'upi_deposit_amount') {
                    item.messageShow = false
                  }
                })
                this.daySpan = res.DaySpan ? res.DaySpan : this.daySpan
                if (this.SevenDayGiftTask.filter((e) => {
                  return e.Status === 0
                }).length > 0) {
                  this.blueBtn = 1
                } else {
                  this.blueBtn = 2
                }
              }
            } else {
              this.mode = 1
              this.depositCoinAmountList = res.DepositSetting
              this.freeCoinAmountList = res.FreeSetting
              // YTW 老用户处理
              let totalEarned = 0
              if (this.depositCoinAmountList && this.depositCoinAmountList.length > 0) {
                this.depositCoinAmountList.forEach((n) => {
                  totalEarned += n * 1
                })
              }
              this.yellowText = totalEarned
              // YTW 老用户处理
              this.mayCollectFree = res.MayCollectFree
              this.mayCollectDeposit = res.MayCollectDeposit
              this.isDeposited = res.IsDeposited
              this.freeCoinList = res.Free
              this.depositCoinList = res.Deposit
              this.collectIndex = res.NumberOfDay
              if (res.SevenDayGiftModel === 'versionC') {
                if (res.VersionCRewardList && res.VersionCRewardList.length !== 0 && res.VersionCWaitClaimTasks && res.VersionCWaitClaimTasks.length !== 0) {
                  res.VersionCRewardList.forEach(item => {
                    if (item.Status === 0) {
                      store.commit('setGiftShowRedCircle', true)
                    }
                  })
                  res.VersionCWaitClaimTasks.forEach(item => {
                    if (item.Status === 0) {
                      store.commit('setGiftShowRedCircle', true)
                    }
                  })
                } else {
                  store.commit('setGiftShowRedCircle', false)
                }
              } else {
                if (!this.mayCollectFree && !this.mayCollectDeposit && (this.collectIndex >= 6 || this.collectIndex < 0)) {
                  this.blueBtn = 2
                } else {
                  this.blueBtn = 1
                }
                store.commit('setGiftShowRedCircle', this.blueBtn === 1)
              }
            }
            this.getBalance()
          }
          this.requestPoint = new Date()
        }).catch(err => {
          console.log(err)
        })
      }
    },
    timeSpanCompute () {
      let time1 = new Date()
      // 计算时间差
      const timeDiff = Math.abs(time1 - this.requestPoint)
      // 判断时间差是否在6秒内
      return timeDiff <= 6000
    },
    getGiftAmount () {
      const url = '/innovation/sevendaygift/get-gift-amount'
      let data = {}
      if (localStorage.getItem('cid')) {
        data.campaignId = localStorage.getItem('cid')
      } else {
        data.campaignId = 'app'
      }
      request('post', url, data, true).then(res => {
        if (res) {
          if (res.SevenDayGiftModel && res.SevenDayGiftModel === 'version_task') {
            this.mode = 2
            res.SevenDayGiftTask.forEach((e, index) => {
              e.index = index
            })
            // 已完成(status=1)的排到后面
            res.SevenDayGiftTask.sort((a, b) => {
              if (a.Status === 1 && b.Status !== 1) {
                return 1 // a排在b后面
              } else if (a.Status !== 1 && b.Status === 1) {
                return -1 // a排在b前面
              } else {
                return 0 // 保持不变
              }
            })
            // 待领取(status=0)的排到后面
            res.SevenDayGiftTask.sort((a, b) => {
              if (a.Status !== 0 && b.Status === 0) {
                return 1 // a排在b后面
              } else if (a.Status === 0 && b.Status !== 0) {
                return -1 // a排在b前面
              } else {
                return 0 // 保持不变
              }
            })
            this.SevenDayGiftTask = res.SevenDayGiftTask
            this.daySpan = res.DaySpan ? res.DaySpan : this.daySpan
          } else {
            this.mode = 1
            this.freeCoinAmountList = res.FreeSetting
            this.depositCoinAmountList = res.DepositSetting
            let totalEarned = 0
            if (this.depositCoinAmountList && this.depositCoinAmountList.length > 0) {
              this.depositCoinAmountList.forEach((n) => {
                totalEarned += n * 1
              })
            }
            this.yellowText = totalEarned
          }
        }
        this.loadData()
      }).catch(err => {
        console.log(err)
      })
    },
    collectGift () {
      if (this.blueBtn !== 1) {
        return
      }
      if (this.userInfo) {
        let url = '/innovation/sevendaygift/collect-gift'
        let data = {
          UserId: this.userInfo.UserId,
          SevenDayGiftModel: this.mode === 1 ? 'free_deposit' : 'version_task'
        }
        request('post', url, data, false).then(res => {
          if (res && (res * 1) > 0) {
            if (this.mayCollectFree && !this.mayCollectDeposit) { // 监听行为
              afListener('FreeSign')
            }
            this.fetchBalance()
            this.loadData()
            this.brownText = this.$t('lang.account.currencyType') + res + ' ' + this.$t('lang.dailyFreeCash.giftReward')
            if (this.isDeposited || this.mode === 2) {
              this.confirmBtn = 2
            } else {
              this.confirmBtn = 1
            }
            this.showConfirm = true
          } else {
            if (this.collectIndex < 7 && this.freeCoinList[this.collectIndex].Status !== 0) {
              this.brownText = this.$t('lang.dailyFreeCash.singedText')
              if (this.isDeposited || this.mode === 2) {
                this.confirmBtn = 2
              } else {
                this.confirmBtn = 1
              }
              this.showConfirm = true
            }
          }
          if (!this.mayCollectFree && !this.mayCollectDeposit && (this.collectIndex >= 6 || this.collectIndex < 0)) {
            this.blueBtn = 2
          } else {
            this.blueBtn = 1
          }
        }).catch(err => {
          console.log(err)
        })
      } else {
        closePop(0)
        this.$router.push('/Login')
      }
    },
    close () {
      this.$emit('openDonwloadBonusPop')
      this.handleClose()
    },
    deposit () {
      this.handleClose()
      this.$router.push('/deposit')
    },
    closeConfirm () {
      if (this.$store.state.showGiftIcon === false) {
        this.showConfirm = false
        this.handleClose()
      } else {
        this.showConfirm = false
      }
    },
    closeAll () {
      this.closeConfirm()
      this.close()
    },
    clkVoid () {
      // 绑定空点击事件防止部分浏览器点击背景图直接弹出图片
    },
    getBalance () {
      let userId = this.userInfo.UserId
      request('post', '/innovation/account/getuserbalance', {
        userId: userId
      }, true).then(res => {
        store.commit('setBalance', res)
        if (res.Inactive === true) {
          localStorage.removeItem('userInfo')
          this.$router.go(0)
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.gift-pop {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, .6);
  z-index: 990;
  padding: 4.739vh 5.128vw;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  background-position: bottom;
  background-origin: border-box;
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  flex-flow: column;
  @media screen and (max-height: 1000px) {
    .coin-image-small-3 {
      position: absolute;
      margin-left: -22%;
      margin-top: -3.2%;
      width: 25.5%;
      height: 60.5%;
      z-index: 2;
    }

    .coin-image-small-2 {
      position: absolute;
      margin-left: -19%;
      width: 19%;
      height: 48%;
      z-index: 11;
    }

    .bg2 {
      position: absolute;
      top: 20.8vh;
      width: 78vw;
      background-color: #FDFBF4;
      height: 58vh;
      left: 50%;
      transform: translate(-50%);
      border-radius: 2.985vh 2.985vh 4.265vh 4.265vh;
      z-index: 2;
      box-shadow: inset 0 0 10px rgba(252, 210, 136, 0.75);
    }
  }
  @media screen and (min-height: 1001px) {
    .coin-image-small-3 {
      position: absolute;
      margin-left: -22%;
      margin-top: -3.2%;
      width: 25.5%;
      height: 65.5%;
      z-index: 2;
    }

    .coin-image-small-2 {
      position: absolute;
      margin-left: -19%;
      width: 19%;
      height: 50%;
      z-index: 11;
    }

    .bg2 {
      position: absolute;
      top: 22vh;
      width: 78vw;
      background-color: #FDFBF4;
      height: 54.8vh;
      left: 50%;
      transform: translate(-50%);
      border-radius: 2.985vh 2.985vh 5vh 5vh;
      z-index: 2;
      box-shadow: inset 0 0 10px rgba(252, 210, 136, 0.75);
    }
  }

  .main-content {
    width: 89.714vw;
    margin-left: auto;
    margin-right: auto;

    .dailyFreeCashTop {
      width: 100%;

      .bg {
        position: absolute;
        z-index: 1;
        width: 89.713vw;
        height: 72.972vh;
      }

      .bgTask {
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        top: 17.5vh;
        z-index: 1;
        width: 89.722vw;
        height: 58.783vh;
        border-radius: 5.555vw;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100% 100%;
      }
    }

    .decorate {
      height: 26.54vh;
      z-index: 6;
      position: absolute;
      left: 50%;
      transform: translate(-50%);
      top: 1.184vh;
      opacity: 0.8;
    }

    .fontTop {
      height: 7.5vh;
      z-index: 4;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 12vh;
    }

    .fontTop1 {
      top: 11.2vh;
      height: 7.297vh;
      z-index: 4;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }

    .fontTop2 {
      top: 20.25vh;
      height: 5.153vh;
      z-index: 4;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }

    .textFree {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      z-index: 3;
      top: 22.511vh;
      width: 70vw;
    }

    .textDeposit {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      z-index: 3;
      top: 49.5vh;
      width: 70vw;
    }

    .freeDiv {
      position: absolute;
      left: 50%;
      top: 27.843vh;
      transform: translateX(-50%);
      width: 70vw;
      height: 17.772vh;
      z-index: 3;
    }

    .depositDiv {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      z-index: 3;
      top: 55vh;
      width: 70vw;
      height: 17.772vh;
    }

    .up {
      position: absolute;
      top: 30.5vh;
      left: 50%;
      transform: translateX(-50%);
      width: 70vw;
      height: 2vh;
      z-index: 4;
      display: flex;
      justify-content: center;
      align-items: flex-start;

      img {
        height: 1.65vh;
      }
    }

    .down {
      position: absolute;
      top: 71.5vh;
      left: 50%;
      transform: translateX(-50%);
      width: 70vw;
      height: 2vh;
      z-index: 4;
      display: flex;
      justify-content: center;
      align-items: flex-start;

      img {
        height: 1.65vh;
      }
    }

    .remainTimes {
      position: absolute;
      top: 27vh;
      left: 50%;
      transform: translateX(-50%);
      z-index: 4;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left {
        margin-right: 1vw;
        height: 2px;
        width: 18.611vw;
        background: #6B6B6B;
      }

      .right {
        margin-left: 1vw;
        height: 2px;
        width: 18.611vw;
        background: #6B6B6B;
      }

      div {
        white-space: nowrap;
        font-size: 1.959vh;
        font-weight: 600;
        text-align: center;
        color: #CFCFCF;
      }

      img {
        margin: 0 1.5vw;
        width: 10vw;
      }
    }

    .taskDiv {
      position: absolute;
      top: 29.8vh;
      left: 50%;
      transform: translateX(-50%);
      width: 79.5vw;
      height: max-content;
      overflow: visible;
      z-index: 3;

      .task-row {
        position: relative;
        top: 4.5vh;
        left: 50%;
        transform: translate(-50%);
        width: 83.343vw;
        height: 35vh;
        padding: 2px 0 5px 0;
        overflow-x: hidden;
        overflow-y: auto;

        .task-item {
          position: relative;
          margin: 1.5vh 1.25vw;
          text-align: center;
          height: 7.567vh;
          overflow: visible;

          .item-back {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background: #F6D9AA;
            z-index: 2;
            border-radius: 2.222vw;
          }

          @keyframes blink {
            0% {
              width: calc(100% + 3px);
              height: calc(7.567vh + 3px);
              transform: translate(-1.5px, -1.5px); /* 使用 transform 替代 position 和 top/left 等 */
              background: linear-gradient(92.61deg, #D10019 -13.54%, #FFFFFF 62.53%, #4E9B00 107.21%);
              border-radius: calc(2.222vw + 1px);
            }
            50% {
              width: calc(100% + 5px);
              height: calc(7.567vh + 5px);
              transform: translate(-2.5px, -2.5px); /* 同样使用 transform */
              background-color: rgba(255, 255, 255, 0.8);
              border-radius: calc(2.222vw + 2px);
            }
            100% {
              width: calc(100% + 6px);
              height: calc(7.567vh + 6px);
              transform: translate(-3px, -3px); /* 使用 transform */
              background-color: rgba(255, 255, 255, 0.5);
              border-radius: calc(2.222vw + 3px);
            }
          }

          .available {
            animation: blink 650ms infinite;
            z-index: 0;
          }
        }

        .query {
          width: 8vw;
          height: 8vw;
          //border: 1px solid red;
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          left: 55vw;
          top: 3.5vw;

          .queryIcon {
            border-radius: 50vw;
            height: 5vw;
            width: 5vw;
            background: rgb(112, 112, 112);
            font-size: 3.6vw;
            color: #fff;
            text-align: center;
            line-height: 5vw;
            user-select: none;
            position: relative;
            z-index: 99;
          }
        }

        .queryMask {
          z-index: 101; /* 设置一个比页面上其他元素都大的z-index值 */
          position: absolute;
          top: 8vw;
          left: -15.5vw;
          width: 22.8vw;
          background: rgb(40, 35, 27);
          background-size: 100%;
          font-size: 2.5vw;
          color: #C3C3C3;
          display: flex;
          padding: 1vw;
          word-wrap: break-word;
          word-break: break-all;
          letter-spacing: 0.1vw;
          border-radius: 1vw;

          .triangle-up {
            width: 0;
            height: 0;
            border-left: 1vw solid transparent;
            border-right: 1vw solid transparent;
            border-bottom: 1.9vw solid rgb(40, 35, 27);
            //background: red;
            position: absolute;
            left: 18.5vw;
            top: -1.5vw;
          }
        }

        .item-inner {
          position: absolute;
          top: 0.591vh;
          right: 1.222vw;
          bottom: 0.591vh;
          left: 1.222vw;
          display: flex;
          justify-content: space-between;
          align-items: center;
          z-index: 3;
        }

        .taskName {
          position: relative;
          top: 0.5vh;
          left: 0;
          height: 6.385vh;
          line-height: 2vh;
          width: 12.183vw;
          font-size: 1.756vh;
          font-weight: 700;
          text-align: center;
          color: #000000;
          display: flex;
          flex-direction: column;
          text-shadow: 0.2px 0.2px 0 #FFFEFE,
          -0.2px 0.2px 0 #FFFEFE,
            0.2px -0.2px 0 #FFFEFE,
            -0.2px -0.2px 0 #FFFEFE,
          0px 0.2px 0 #FFFEFE,
            0px -0.2px 0 #FFFEFE,
          -0.2px 0px 0 #FFFEFE,
          0.2px 0px 0 #FFFEFE;

          div {
            width: 12.183vw;
          }
        }

        .taskShadowBoxRight {
          width: 17vw;
          border-radius: 0 2.222vw 2.222vw 0vw;
          overflow: hidden;
          //border: 1px solid #00c620;

        }

        .taskShadowBox {
          //border: 1px solid red;
          position: relative;
          left: 0;
          top: 0;
          //width: 100%;
          height: 100%;
          background: #FFFFFF;
          border-radius: 2.222vw;
          box-shadow: 0px 0px 1.4vw 0px rgba(0, 0, 0, 0.85) inset;
          display: flex;
          justify-content: space-between;
          //overflow: hidden;
          z-index: 4;

          .taskImg {
            position: relative;
            width: max-content;
            height: 6.385vh;
            overflow: hidden;

            .bigCoin {
              position: relative;
              z-index: 0;
              width: max-content;
              height: 6.385vh;

              img {
                width: auto;
                height: 100%;
              }
            }

            .task-amount {
              position: absolute;
              bottom: 0.35vh;
              width: 18.3vw;
              height: max-content;
              text-align: center;
              font-size: 1.756vh;
              font-weight: 700;
              z-index: 1;
              color: #FFFFFF;
              letter-spacing: 0.04em;
              text-shadow: 1px 1px 0 #000000,
              -1px 1px 0 #000000,
                1px -1px 0 #000000,
                -1px -1px 0 #000000,
              0px 1px 0 #000000,
                0px -1px 0 #000000,
              -1px 0px 0 #000000,
              1px 0px 0 #000000,
              1.5px 1.5px 0 #000000,
              -1.5px 1.5px 0 #000000,
                1.5px -1.5px 0 #000000,
                -1.5px -1.5px 0 #000000,
              0px 1.5px 0 #000000,
                0px -1.5px 0 #000000,
              -1.5px 0px 0 #000000,
              1.5px 0px 0 #000000,
              1px 1.5px 0 #000000,
              -1px 1.5px 0 #000000,
                1px -1.5px 0 #000000,
                -1px -1.5px 0 #000000,
              1.5px 1px 0 #000000,
              -1.5px 1px 0 #000000,
                1.5px -1px 0 #000000,
                -1.5px -1px 0 #000000;
            }

            .ok {
              position: absolute;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              background-color: rgba(0, 0, 0, 0.75);
              border-radius: 0 2.222vw 2.222vw 0;
              z-index: 11;
              display: flex;
              justify-content: center;
              align-items: center;

              img {
                height: 3vh;
              }
            }
          }

          .task-content {
            height: 6.385vh;
            width: 48.055vw;
            font-weight: 600;
            text-align: left;
            color: #000000;
            font-size: 1.891vh;
            padding-left: 3.5vw;
            display: flex;
            align-items: center;
            //border: 1px solid #0fabff;
            div {
              width: 100%;
            }
          }
        }
      }

      .task-row::-webkit-scrollbar {
        display: none;
      }
    }

    .coin-row {
      display: flex;
      align-items: flex-end;
      align-self: center;
      padding: 5px 0px;
      width: 100%;
      height: 55%;

      .coin-item {
        flex: 1;
        text-align: center;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        height: 100%;
        margin: 0px 0px 10px 0px;

        .coin-image-small-1 {
          width: 75%;
          height: 100%;
          z-index: 9;
          border-radius: 1.538vw;
          box-shadow: 0 3px 3px rgba(0, 0, 0, 0.3);
        }

        .coin-text {
          position: absolute;
          width: 17%;
          margin-left: 4%;
          margin-top: -2.606vh;
          z-index: 10;
          font-size: 2.132vh;
          line-height: 2.132vh;
          -webkit-transform: scale(0.5);
          color: #ffffff;
        }
      }
    }

    .operation-row {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
      width: 89vw;
      top: calc(77.5vh + 12.5vw);
      display: flex;
      margin: 3.5vw 0 0 0;
      height: max-content;
      justify-content: space-between;
      z-index: 10;

      .operation-item {
        text-align: center;
        color: #FFFFFF;
        line-height: 12.5vw;
        height: 12.5vw;
        width: 41.666vw;

        .blue-btn-1 {
          width: 100%;
          margin: 0 auto;
          white-space: nowrap;
          overflow: hidden;
          font-size: 5.833vw;
          background-color: #F6D9AA;
          border-radius: 2.777vw;
          color: #000000;
          font-weight: 700;
          letter-spacing: -0.05em;
        }

        .blue-btn-2 { // disable
          width: 100%;
          margin: 0 auto;
          white-space: nowrap;
          overflow: hidden;
          font-size: 5.833vw;
          border-radius: 2.777vw;
          color: #A2A2A2;
          background-color: #5E5E5E;
          font-weight: 700;
          letter-spacing: -0.05em;
        }

        .green-btn-1 {
          width: 100%;
          margin: 0 auto;
          white-space: nowrap;
          overflow: hidden;
          font-size: 5.833vw;
          background-color: #F6D9AA;
          border-radius: 2.777vw;
          color: #000000;
          font-weight: 700;
          letter-spacing: -0.05em;
        }

      }
    }

    .operation-row2 {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
      width: 86vw;
      top: calc(72vh + 12.5vw);
      display: flex;
      margin: 3.5vw 0 0 0;
      height: max-content;
      justify-content: space-between;
      z-index: 10;

      .operation-item {
        text-align: center;
        color: #FFFFFF;
        line-height: 5.945vh;
        height: 5.945vh;
        width: 41.666vw;

        .blue-btn-1 {
          width: 100%;
          margin: 0 auto;
          white-space: nowrap;
          overflow: hidden;
          font-size: 5.833vw;
          background-color: #F6D9AA;
          border-radius: 2.777vw;
          color: #000000;
          font-weight: 700;
          letter-spacing: -0.05em;
        }

        .blue-btn-2 { // disable
          width: 100%;
          margin: 0 auto;
          white-space: nowrap;
          overflow: hidden;
          font-size: 5.833vw;
          border-radius: 2.777vw;
          color: #A2A2A2;
          background-color: #5E5E5E;
          font-weight: 700;
          letter-spacing: -0.05em;
        }

        .green-btn-1 {
          width: 100%;
          margin: 0 auto;
          white-space: nowrap;
          overflow: hidden;
          font-size: 5.833vw;
          background-color: #F6D9AA;
          border-radius: 2.777vw;
          color: #000000;
          font-weight: 700;
          letter-spacing: -0.05em;
        }

      }
    }
  }

  .close-btn {
    position: relative;
    width: 100%;
    height: 4.739vh;
    z-index: 20;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;

    img {
      width: 4.723vw;
      margin-right: 0;
    }
  }

  .close-btn2 {
    position: absolute;
    top: 11vh;
    width: 89vw;
    height: 4.739vh;
    z-index: 20;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;

    img {
      width: 5vw;
      margin-right: 0;
    }
  }

  .textShadow {
    text-shadow: -1px -1px 0 #039590,
      1px -1px 0 #039590,
    -1px 1px 0 #039590,
    1px 1px 0 #039590;
  }
}
.notlogined{
  width: 99.566vw;
  height: 128.05vw;
  background-size: 100% 100%;
  position: relative;
  top: 25vw;
  left:-2.5vw;
  .close{
    position: absolute;
    bottom: -8vw;
    left: 44vw;
    height: 4.222vw;
    width: 3.888vw;
  }
  .contentBox{
    height: 73.333vw;
    //width: 58.333vw;
    display: flex;
    flex-direction: column;
    gap: 2vw;
    position: absolute;
    left: 10.88vw;
    top: 58vw;
   display: flex;
    flex-direction: column;
    align-items: center;
    .amount{
      /* ₹117 */
      font-family: 'Inter';
      font-style: normal;
      font-weight: 700;
      font-size: 40px;
      line-height: 48px;
      text-transform: capitalize;
      color: #FFEB38;
    }
    .getUp{
      /* Get upon registration */
      font-family: 'Inter';
      font-style: normal;
      font-weight: 700;
      font-size: 21px;
      line-height: 25px;
      letter-spacing: 0.01em;
      color: #FFFFFF;
      margin-top: 2.777vw;
    }
    .exFNU{
      /* Exclusive for new users */
      font-family: 'Inter';
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      text-transform: capitalize;
      color: #777777;
      margin-top: 8.055vw;
    }
    .btn{
      /* Rectangle 3 */
      background: #EE3838;
      border-radius: 1.111vw;
      font-family: 'Inter';
      font-style: normal;
      font-weight: 600;
      font-size: 4.444vw;
      text-align: center;
      text-transform: capitalize;
      color: #FFFFFF;
      height: 10.277vw;
      width: 73.333vw;
      line-height: 10.277vw;
      margin-top: 4.166vw;
    }
    .iAlreadyLogin{
      color: #454545;
      font-size: 3.611vw;
      display: flex;
      align-items: center;
      margin-top: 3.611vw;
      span{
        color: #218FC2;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DailyFreeCash/index.vue